module.exports = __webpack_public_path__ + "assets/img/ic-grayball.bdd9da0f.svg";